import * as React from 'react';
import { memo } from 'react';
import { useResponsiveBreakPoints } from '@restworld/utils-common';

import { Modal } from '..';
import ModalHeader from '../modal-header';
import { ModalContent } from '../modal-content';

export type ModalVariant = 'secondary' | 'primary' | 'tertiary';

type MobileModalProps = {
  show: boolean;
  close: () => void;
  children: React.ReactNode;
  variant?: ModalVariant;
  closebutton?: boolean;
  haltGestures?: boolean;
};
export const MobileModal = memo(function ({
  show,
  close,
  children,
  closebutton = true,
  variant = 'primary',
  haltGestures,
}: MobileModalProps) {
  const { isDesktop } = useResponsiveBreakPoints();

  return (
    <Modal haltGestures={haltGestures} layout="modal" isOpen={show} onClose={close} variant={variant}>
      <div className="md:overflow-y-auto md:max-h-[90vh]">
        {closebutton && isDesktop ? (
          <ModalHeader variant="desktop-with-title-close-button" onClose={close}></ModalHeader>
        ) : (
          <ModalHeader variant="mobile-without-title" />
        )}

        <ModalContent>{children}</ModalContent>
      </div>
    </Modal>
  );
});
